<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row no-gutters class="justify-start" :class="[alignClass]">
        <v-col :cols="isSuperadmin ? 6 : 3" class="pr-5 text-left" v-if="isNamedSlot">
          <v-row no-gutters>
            <v-col cols="12">
              <v-subheader
                class="font--text px-0"
                style="height: auto"
                :class="{
                  'font-weight-medium': isSuperadmin && !isSubsection,
                  'text-subtitle-1': isSuperadmin,
                  'text--disabled': disabled,
                }"
              >
                {{ subheader }}
              </v-subheader>
            </v-col>
            <v-col cols="12" class="text-left mt-n1 pt-1">
              <italic-subheader :translation-path="subtitle" :params="subtitleParams"> </italic-subheader>
            </v-col>
          </v-row>
        </v-col>
        <slot :name="`${name}.input`" v-bind="{ ...$attrs, ...$props }">
          <v-col>
            <v-row no-gutters>
              <v-col :cols="inputCols" :class="inputColClasses.join(' ')">
                <admin-input-row-wrapper
                  ref="input"
                  v-bind="{ ...$attrs, ...$props }"
                  :dataType="dataType"
                  v-on="computedListeners"
                >
                  <template #[name]="scope">
                    <slot :name="`${name}.input.inner`" v-bind="scope" />
                  </template>
                </admin-input-row-wrapper>
              </v-col>
            </v-row>
          </v-col>
        </slot>
      </v-row>
      <v-row no-gutters>
        <v-col class="pa-0">
          <slot :name="`${name}.bottom`" v-bind="{ ...$attrs, ...$props }"></slot>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import AdminInputRowWrapper from '@/components/AdminInputRowWrapper';
import ItalicSubheader from '@/components/ItalicSubheader';

export default {
  name: 'AdminInputRow',
  components: {
    AdminInputRowWrapper,
    ItalicSubheader,
  },
  inheritAttrs: false,
  props: {
    inputCols: {
      type: String,
      default: '4',
    },
    inputColClasses: {
      type: Array,
      default: () => {
        return [];
      },
    },
    straightText: {
      type: String,
      default: '',
    },
    isNamedSlot: {
      type: Boolean,
      default: true,
    },
    isCustom: {
      type: Boolean,
      default: false,
    },
    dataType: {
      type: Object,
      default: () => {},
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    isSubtitle: {
      type: Boolean,
      default: false,
    },
    translationPath: {
      type: String,
      default: '',
    },
    isPlural: {
      type: Boolean,
      default: false,
    },
    amount: {
      type: Number,
      default: 0,
    },
    /**
     * Title that should not be translated, e.g layer card title.
     */
    straightTitle: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    subtitleParams: {
      type: Object,
      default: () => {},
    },
    align: {
      type: String,
      default: 'baseline',
    },
    isSuperadmin: {
      type: Boolean,
      default: false,
    },
    hasSuffix: {
      type: Boolean,
      default: true,
    },
    isSubsection: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    canBeDisabled: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    alignClass() {
      return `align-${this.align}`;
    },
    subheader() {
      return this.straightText
        ? this.straightText + (this.hasSuffix ? ':' : '')
        : this.$i18n.t(this.translationPath) + (this.hasSuffix ? ':' : '');
    },
    computedListeners() {
      return {
        ...this.$listeners,
        change: e => {
          this.$emit('change', e, this.name);
        },
        input: e => {
          this.$emit('input', e, this.name);
        },
      };
    },
  },
  methods: {
    save() {
      if (!this.$refs.input) {
        return;
      }
      this.$refs.input.save();
    },
  },
};
</script>

<style lang="scss" scoped></style>
